import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {DictionaryState} from '../../../../state/dictionary/dictionary.state';
import {Dictionary} from '../../../../models/dictionary.model';
import {DictionaryCode} from '../../../../enums/dictionary-code.enum';
import {SelectSnapshot} from '@ngxs-labs/select-snapshot';

@Component({
    selector: 'app-address-form',
    templateUrl: './address-form.component.html',
})
export class AddressFormComponent implements OnInit {
    @SelectSnapshot(DictionaryState.getDictionary(DictionaryCode.ADDRESS_COUNTRY)) countryDictionary: Dictionary;
    @SelectSnapshot(DictionaryState.getDictionary(DictionaryCode.ADDRESS_STREET_PREFIX)) streetDictionary: Dictionary;
    @SelectSnapshot(DictionaryState.getDictionary(DictionaryCode.ADDRESS_VOIVODESHIP)) voivodeshipDictionary: Dictionary;

    @Input() group: AbstractControl = new FormGroup({});
    @Input() hiddenFields: string[] = [];
    @Input() header: string = null;
    @Input() tooltips: any = {};

    ngOnInit() {
        if (this.group.get('country').value === '') {
            const country = this.countryDictionary?.itemList?.find((item) => {
                return item?.code.valueOf() === 'PL';
            });
            if (country) {
                this.group.get('country').setValue(country);
            }
        }
    }
}
